import { get, isNil, isObject } from 'lodash-es';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getDisplayName(value?: any, displayNamePropertyName: string = 'displayName'): string {
	return isObject(value)
	// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
		? get(value, displayNamePropertyName) ?? get(value, 'name') ?? value.toString()
		: (isNil(value) ? 'No Display Value' : `${ value }`);
}
